<script lang="ts" setup>
import { computed } from 'vue'
import type { ImgHTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    src?: string
    alt?: string
    width?: number
    height?: number
    imgAttrs?: Omit<ImgHTMLAttributes, 'id'>
  }>(),
  {
    src: '',
    alt: '',
  },
)

const resizeImage = computed(() => {
  return resizer(props.src, props.width, props.height)
})

const resizer = (src: string, width?: number | undefined, height?: number | undefined) => {
  return window.GalaxyHelpers.resizeImg(src, width, height)
}
</script>
<template>
  <img
    :src="resizeImage"
    :alt="alt"
    :width="width"
    :height="height"
    v-bind="imgAttrs"
  />
</template>
